/**
 * Daily summary data structure
 */
export interface DailySummary {
  date: string
  total_quantity: number
  activity_count: number
  completed_quantity: number
  future_quantity: number
}

/**
 * Data point for cumulative chart
 */
export interface CumulativeDataPoint {
  date: string
  cumulative_completed: number
  cumulative_total: number
}

/**
 * Calculate cumulative data from daily summary
 * @param dailySummary Array of daily summary data
 * @returns Array of cumulative data points
 */
export function calculateCumulativeData(dailySummary: DailySummary[]): CumulativeDataPoint[] {
  let cumulativeCompleted = 0
  let cumulativeTotal = 0

  return dailySummary.map((day) => {
    cumulativeCompleted += day.completed_quantity
    cumulativeTotal += day.total_quantity

    return {
      date: day.date,
      cumulative_completed: cumulativeCompleted,
      cumulative_total: cumulativeTotal,
    }
  })
}

